// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"registrationInitialization_wrapper__2d1fR"};